/**
 * Leitura do texto de PDFs no próprio navegador (pdf.js), para sugerir datas e CNPJs (D66).
 * Carregado sob demanda: a biblioteca só é baixada quando há PDF para ler.
 * PDFs escaneados (só imagem) não têm texto: o resultado vem vazio e o preenchimento fica manual.
 */
let carregamento: Promise<typeof import("pdfjs-dist")> | null = null;

async function pdfjs() {
  if (!carregamento) {
    carregamento = (async () => {
      const biblioteca = await import("pdfjs-dist");
      const trabalhador = await import("pdfjs-dist/build/pdf.worker.min.mjs?url");
      biblioteca.GlobalWorkerOptions.workerSrc = trabalhador.default;
      return biblioteca;
    })();
  }
  return carregamento;
}

/** Texto das primeiras páginas do PDF (padrão: 3). Vazio quando não é PDF, está protegido ou é só imagem. */
export async function textoDoPdf(arquivo: File, paginas = 3): Promise<string> {
  if (arquivo.type !== "application/pdf") return "";
  try {
    const biblioteca = await pdfjs();
    const tarefa = biblioteca.getDocument({ data: new Uint8Array(await arquivo.arrayBuffer()) });
    const documento = await tarefa.promise;
    const partes: string[] = [];
    for (let i = 1; i <= Math.min(paginas, documento.numPages); i++) {
      const pagina = await documento.getPage(i);
      const conteudo = await pagina.getTextContent();
      partes.push(conteudo.items.map((item) => ("str" in item ? item.str : "")).join(" "));
    }
    await tarefa.destroy();
    return partes.join("\n");
  } catch {
    return "";
  }
}
